import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let NumberDesign = class NumberDesign extends Vue {
    // @Prop({default:{}})
    // opts!:any
    render(h) {
        const that = this;
        return h('a-input-number', { props: {
                disabled: true,
                placeholder: that.$t('cloudpivot.form.dataitem.InputPlaceholder').toString(),
            } });
    }
};
NumberDesign = tslib_1.__decorate([
    Component({ name: 'NumberDesign' })
], NumberDesign);
export default NumberDesign;
